import { Fragment, ReactNode } from 'react';

/** Adds random keys to a list of react nodes */
export default function randomKeys(nodes: ReactNode[]) {
  return nodes.map((node) => <Fragment key={Math.random()}>{node}</Fragment>);
}
